import React, { forwardRef, useImperativeHandle, useState } from "react";
import BaseImport from "../Imports/BaseImport";

const BaseImportModal = forwardRef(({ importData, apiURL }, ref) => {
  const [show, setShow] = useState(false);
  useImperativeHandle(ref, () => ({
    open: () => {
      setShow(true);
    },
    close: () => {
      setShow(false);
    },
  }));

  return (
    <BaseImport
      setShow={setShow}
      show={show}
      api={apiURL}
      codeColumnName={importData.codeColumnName}
      columnNames={importData.columnNames}
      dataName={importData.dataName}
    />
  );
});

export default BaseImportModal;
